module.exports = __webpack_public_path__ + "static/img/skill-PUBG.b266ba2d.png";